import { memo } from 'react';
import { Stack, Box } from '@chakra-ui/layout';
import { Alert, AlertIcon } from '@chakra-ui/alert';

import { FileUploaderListItem } from './FileUploaderListItem';
import { FileUploaderCopyButton } from './FileUploaderCopyButton';

import type { FileAttachment } from '@/modules/fileUploader/fileUploaderEntity';

type FileUploaderListProps = {
  files: Array<FileAttachment>;
  onDeleteFile: (deletedUrl: string) => void;
};

const FileUploaderList = memo(
  ({ files, onDeleteFile }: FileUploaderListProps) => {
    return (
      <Stack>
        <Alert status="info" variant="left-accent" borderRadius="lg">
          <AlertIcon />
          The file list below is only saved on your browser device
        </Alert>
        <FileUploaderCopyButton files={files} />
        <Stack>
          <Stack direction="row" px="1rem" py="0.5rem">
            <Box flex="1" borderRight="1px solid" borderColor="gray.200">
              No
            </Box>
            <Box flex="5" borderRight="1px solid" borderColor="gray.200">
              Filename
            </Box>
            <Box flex="3" borderRight="1px solid" borderColor="gray.200">
              Preview
            </Box>
            <Box
              flex="9"
              display={{ base: 'none', md: 'block' }}
              borderRight="1px solid"
              borderColor="gray.200"
            >
              Link
            </Box>
            <Box flex="2">&nbsp;</Box>
          </Stack>
          {files.length <= 0 ? (
            <Stack
              direction="row"
              background="white"
              boxShadow="0px 4px 12px -8px rgba(0, 0, 0, 0.2)"
              borderRadius="lg"
              px="1rem"
              py="0.5rem"
            >
              <Box flex="1" textAlign="center" fontSize="sm">
                No files uploaded yet
              </Box>
            </Stack>
          ) : (
            files.map((file, i) => (
              <FileUploaderListItem
                key={i}
                no={i + 1}
                name={file.name}
                url={file.url || ''}
                onDeleteFile={onDeleteFile}
              />
            ))
          )}
        </Stack>
      </Stack>
    );
  },
);

export { FileUploaderList };
